import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { MARKETING_ROUTES } from "./routes";

export default function CTASection({
  heading = "Ready to Simplify HR and Payroll?",
  description,
  statement,
  primaryLabel = "Get Started",
  primaryTo = MARKETING_ROUTES.login,
  secondaryLabel = "Contact Us",
  secondaryTo = MARKETING_ROUTES.contact,
}) {
  return (
    <section className="mk-cta-sec" aria-labelledby="mk-cta-heading">
      <div className="mk-cta-card">
        <div className="mk-cta-glow" aria-hidden="true" />
        <div className="mk-cta-inner">
          <h2 id="mk-cta-heading" className="mk-cta-heading">{heading}</h2>
          {description ? <p className="mk-cta-desc">{description}</p> : null}
          {statement ? <p className="mk-cta-statement">{statement}</p> : null}
          <div className="mk-cta-actions">
            <Link to={primaryTo} className="mk-btn mk-btn-primary">
              {primaryLabel} <ArrowRight size={16} strokeWidth={2.4} />
            </Link>
            <Link to={secondaryTo} className="mk-btn mk-btn-ghost">
              {secondaryLabel}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
